export default __webpack_public_path__ + "static/media/DisneyBelle1.a5ac7bfd.jpg";